export function toTitleCase(value: string | null | undefined): string {
  if (value == null || value === '') return '';
  return String(value)
    .toLowerCase()
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
